import React from "react";
const Header = () => {
  return (
    <nav
      className="navbar navbar-expand-lg bg-body-tertiary"
      style={{ backgroundColor: "#6A0DAD" }}
    >
      <div className="container-fluid">
        <a className="navbar-brand" href="https://nust.edu.pk">
          <img
            src={process.env.PUBLIC_URL + "/Images/Icons/NUSTLogo.png"}
            width="65"
            alt="NUST"
          />
        </a>
        <a className="navbar-brand" href="/">
          Research Collaboration Portal
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 fw-bold">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/faqs">
                FAQs
              </a>
            </li>
            {/* <li className="nav-item">
                            <a className="nav-link" href="https://research.nust.edu.pk/">About</a>
                        </li> */}
            <li className="nav-item">
              <a className="nav-link" href="/contact">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Header;
